import * as React from 'react'
import { Text } from 'web-makeup/dist/design-system/styles/typography'

import { Container } from './InfoBlock.style'

interface InfoBlockProps {
  validFields: {
    title: boolean
    location: boolean
    dueDate: boolean
    budget: boolean
    terms: boolean
  }
}
const InfoBlock: React.FC<InfoBlockProps> = ({
  validFields: { title, location, dueDate, budget, terms },
}) => {
  const warningIcon = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7422 0C6.11406 0 0.742188 5.37188 0.742188 12C0.742188 18.6281 6.11406 24 12.7422 24C19.3703 24 24.7422 18.6281 24.7422 12C24.7422 5.37188 19.3703 0 12.7422 0ZM20.0335 19.2914C19.0866 20.2383 17.9827 20.9836 16.7546 21.5016C15.4843 22.0406 14.1343 22.3125 12.7421 22.3125C11.3499 22.3125 9.99991 22.0406 8.7296 21.5039C7.50147 20.9836 6.39991 20.2406 5.45069 19.2937C4.50381 18.3469 3.7585 17.243 3.24053 16.0148C2.70147 14.7422 2.4296 13.3922 2.4296 12C2.4296 10.6078 2.70147 9.25781 3.23819 7.9875C3.7585 6.75937 4.50147 5.65781 5.44835 4.70859C6.39522 3.76172 7.49913 3.01641 8.72725 2.49844C9.99991 1.95938 11.3499 1.6875 12.7421 1.6875C14.1343 1.6875 15.4843 1.95938 16.7546 2.49609C17.9827 3.01641 19.0843 3.75937 20.0335 4.70625C20.9804 5.65312 21.7257 6.75703 22.2437 7.98516C22.7827 9.25781 23.0546 10.6078 23.0546 12C23.0546 13.3922 22.7827 14.7422 22.246 16.0125C21.7257 17.2406 20.9827 18.3445 20.0335 19.2914ZM15.5125 16.5371H13.5156V8.33164C13.5156 7.86523 13.1383 7.48789 12.6719 7.48789H11.8281H10.4219C9.95546 7.48789 9.57811 7.86523 9.57811 8.33164C9.57811 8.79805 9.95546 9.17539 10.4219 9.17539H11.8281V16.5371H9.83124C9.36483 16.5371 8.98749 16.9145 8.98749 17.3809C8.98749 17.8473 9.36483 18.2246 9.83124 18.2246H11.8281H13.5156H15.5125C15.9789 18.2246 16.3562 17.8473 16.3562 17.3809C16.3562 16.9145 15.9789 16.5371 15.5125 16.5371ZM11.8281 5.16797C11.8281 4.70198 12.2058 4.32422 12.6718 4.32422C13.1378 4.32422 13.5156 4.70198 13.5156 5.16797C13.5156 5.63396 13.1378 6.01172 12.6718 6.01172C12.2058 6.01172 11.8281 5.63396 11.8281 5.16797Z"
        fill="#EE5A5A"
      />
    </svg>
  )
  return (
    <>
      <Container>
        {warningIcon}
        <div>
          <Text as="h5" fontSize="h5" color="midnight">
            Following information is missing:
          </Text>
          <ul>
            {title && (
              <li>
                <Text as="h5" fontSize="h5" color="midnight">
                  Project name
                </Text>
              </li>
            )}
            {location && (
              <li>
                <Text as="h5" fontSize="h5" color="midnight">
                  Location
                </Text>
              </li>
            )}
            {dueDate && (
              <li>
                <Text as="h5" fontSize="h5" color="midnight">
                  Due date
                </Text>
              </li>
            )}
            {budget && (
              <li>
                <Text as="h5" fontSize="h5" color="midnight">
                  Budget
                </Text>
              </li>
            )}
            {terms && (
              <li>
                <Text as="h5" fontSize="h5" color="midnight">
                  Terms & Conditions
                </Text>
              </li>
            )}
          </ul>
        </div>
      </Container>
    </>
  )
}

export default InfoBlock



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/ProductPrice/InfoBlock.tsx